import { Component, Host, h, Prop, Element } from '@stencil/core';
import axios from '../../../utils/get-axios';
const ACC = (window as any).ACC;

@Component({
  tag: 'lilu-async-element',
  styleUrl: 'lilu-async-element.scss',
  shadow: false,
})
export class LiluAsyncElement {
  @Element() el;
  @Prop() url: string = null;
  @Prop() nooverlay: string = null;
  @Prop() method = 'get';

  useOverlay() {
    return !(this.nooverlay && this.nooverlay.trim() !== '');
  }

  componentDidLoad() {
    let overlay;

    if (this.useOverlay()) {
      overlay = document.createElement('div');
      overlay.classList.add('isLoading');
      overlay.addEventListener('click', () => {
        this.el.shadowRoot.querySelector('.isLoading').remove();
      });
      const spinner = document.createElement('div');
      spinner.classList.add('spinner');
      overlay.append(spinner);
    }

    if (this.method === 'get') {
      this.executeGetRequest(overlay);
    } else {
      this.executePostRequest(overlay);
    }

    if (this.useOverlay()) {
      this.el.prepend(overlay);
    }
  }

  serializeParametersInputs() {
    const inputs = this.el.querySelectorAll('input[type=hidden]');
    let parameters: any = {};

    inputs.forEach(input => {
      const name = input.getAttribute('name');
      const value = input.getAttribute('value');

      parameters[name] = value;
    });

    return parameters;
  }

  executePostRequest(overlay) {
    axios
      .post(this.url, this.serializeParametersInputs(), {
        headers: {
          CSRFToken: ACC.config.CSRFToken,
        },
      })
      .then(response => {
        this.writeContent(response);
      })
      .catch(error => {
        console.error('error', error);
        this.fillOverlay(error, overlay);
      });
  }

  executeGetRequest(overlay) {
    axios
      .get(this.url)
      .then(response => {
        this.writeContent(response);
      })
      .catch(error => {
        console.error('error', error);
        this.fillOverlay(error, overlay);
      });
  }

  writeContent(response) {
    let responseData = response.data.elementHtml || response.data.content || ' ';

    if (responseData) {
      this.el.innerHTML = responseData;
      this.el.shadowRoot?.replaceChildren();
      this.el.shadowRoot?.append(...this.el.childNodes);
    }
  }

  fillOverlay(error, overlay) {
    if (this.useOverlay()) {
      const errorDiv = document.createElement('div');
      errorDiv.classList.add('hasError');
      errorDiv.innerHTML = `<p>${error.message}<p>`;
      overlay.append(errorDiv);
    }
  }

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
